<template>
  <div>
    <h1>Liste de Couleurs</h1>
    <ul>
      <li v-for="color in colors" :key="color.id" :style="{ backgroundColor: color.exa }">
        {{ color.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      colors: []
    };
  },
  created() {
    this.fetchColors();
  },
  methods: {
    async fetchColors() {
      try {
        const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
        const response = await axios.get(`${API_URL}/api/colors`);
        // Assigner directement les données de couleur de la réponse
        this.colors = response.data;
      } catch (error) {
        console.error('Erreur lors de la récupération des couleurs:', error);
      }
    }
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  padding: 10px;
  margin: 5px 0;
  color: white;
  text-align: center;
}
</style>
